import app from '@/app';

/* @ngInject */
function stateConfig($stateProvider, PAGE_SIZES, SMALL_PAGE_SIZES) {
	var states = [
		{
			name: 'allPlansByRoad',
			parent: 'analysis',
			url:
				'/allPlansByRoads?page&sort&size&organization',
			data: {
				viewAuthorities: ['ANALYSIS_READ', 'PLANS_READ'],
				editAuthorities: ['ANALYSIS_WRITE', 'PLANS_WRITE']
			},
			component: 'allPlansByRoadSearch',
			params: {
				size: {
					value: PAGE_SIZES[0],
					type: 'int',
					squash: true,
					dynamic: true
				},
				page: {
					value: 0,
					type: 'int',
					squash: true,
					dynamic: true
				},
				sort: {
					value: 'name,asc',
					squash: true,
					dynamic: true
				},
				organization: {
					type: 'int',
					squash: true,
					dynamic: true
				},
        plans: {
          value: [],
          dynamic: true
        }
			},
			resolve: {
				/* @ngInject */
				allOrganizations: [
					'Organization',
					Organization => {
						return Organization.query({ sort: 'name,asc' }).$promise;
					}
				],
				/* @ngInject */
				allRoads: Road => Road.query({ sort: 'name,asc', empty: false }).$promise,
				/* @ngInject */
				allCampaigns: Campaign =>
					Campaign.query({ sort: 'name,asc', empty: false }).$promise,
				/* @ngInject */
				allDecisionTrees: DecisionTree => DecisionTree.query({ sort: 'name,asc' }).$promise,
				/* @ngInject */
				allCostTables: CostTable => CostTable.query({ sort: 'name,asc' }).$promise,

				/* @ngInject */
				allGrowthRates: GrowthRate => GrowthRate.query({ query: '' }).$promise,
			}
		},
    {
			name: 'allPlansByRoad.result',
			url: '/result?page&size&sort',
			component: 'allPlansByRoadTable',
			params: {
				page: {
					value: 0,
					type: 'int',
					squash: true,
					dynamic: true
				},
				size: {
					value: PAGE_SIZES[0],
					type: 'int',
					squash: true,
					dynamic: true
				},
				sort: {
					value: 'campaign,asc',
					squash: true,
					dynamic: true
				}
			},
			resolve: {
        /* @ngInject */
				allPlans: Plan =>
          Plan.query({plantype: 'DEFAULT'}).$promise,
				/* @ngInject */
				allMetrics: Metadata =>
					Metadata.getMetrics({ measurement: 'KPI', view: 'ANALYSIS' })
			}
		},
	];

	states.forEach(state => $stateProvider.state(state));
}

app.config(stateConfig);
